import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { PaymentForm } from '@components';
import config from '@config';
import { ROUTE_PATHS } from '@constants';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import { APPEARANCE } from './constants';

const AddPaymentMethodContent = ({ clientSecret, onCancel }) => {
    const stripePromise = useMemo(() => loadStripe(config.stripePublishKey), []);
    const params = useParams();
    const returnUrl = `${window.location.origin}${ROUTE_PATHS.LAUNCH_CHECK}/${params?.id}`;
    const stripeOptions = { clientSecret, appearance: APPEARANCE };

    return (
        <Elements stripe={stripePromise} options={stripeOptions}>
            <PaymentForm onCancel={onCancel} returnUrl={returnUrl} />
        </Elements>
    );
};

export default AddPaymentMethodContent;
